module.exports = __webpack_public_path__ + "img/loading.7d02a51.jpg";